module.exports = __webpack_public_path__ + "static/media/sound-off.8db7232c.svg";